import type { parentModelItem } from "../recoil";

// project.config.autoTrain — 실행은 백엔드 backend/src/services/autoTrainScheduler.ts 가 담당 (타입 동일하게 유지)
export interface InspAutoTrainCondition {
  type: "weekly" | "monthly";
  dayOfWeek: number; // 0(일) ~ 6(토)
  week: number; // monthly 전용: 해당 월의 n번째 요일 (1~5)
  time: string; // "HH:mm" KST. JSON 문자열로 저장되므로 DB 타임존 변환을 타지 않음
}

export interface InspAutoTrainConfig {
  enabled: boolean;
  condition: InspAutoTrainCondition;
  serverAddress: string; // import 된 AI 서버가 없을 때 import 할 서버
  train: {
    epoch: number;
    imgPerEpoch: number;
    imgCount: number;
    overkillCondition: number; // %
    parentModel: parentModelItem | null; // 이어학습 모델
  };
  savedAt: number; // epoch ms. 저장 이전 회차는 실행하지 않음
  lastRunAt: number | null; // epoch ms
}

export const DEFAULT_AUTO_TRAIN_CONDITION: InspAutoTrainCondition = {
  type: "weekly",
  dayOfWeek: 1,
  week: 1,
  time: "02:00",
};
